<template>
    <div class="general-text-wrapper">
        <UiGeneralText class="general-text" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
defineProps({ blok: Object });
</script>
<style lang="postcss" scoped>
.general-text-wrapper {
    @apply w-max max-w-full;
    .general-text {
        @apply leading-normal;
        --paragraph-font-weight: 500;
        :deep(.container) {
            > h1 {
                @apply tracking-[0.066rem] opacity-[0.98] leading-[29px] md:font-semibold font-normal text-[#447bbe] text-[1.45rem] mb-4;
            }

            p {
                @apply font-medium tracking-[0.066rem] text-[#5a5e6b] box-border leading-6 mt-0 mb-4;
                font-weight: var(--paragraph-font-weight);
            }

            a {
                @apply text-[#74a703];

                &:hover {
                    @apply underline;
                }
            }

            ul {
                li {
                    span:first-child.css-list-checkmarks:after {
                        @apply left-[-1.4rem] h-4 w-4 text-[#5a5e6b] pr-4 top-[3px] content-[url(~/assets/images/check.svg)];
                    }

                    p {
                        @apply mb-2;
                    }
                }
            }
        }
    }
}
</style>
